export default [
  {
    path: '/app/sustainability',
    name: 'Sustainability',
    component: () => import('@/views/Admin/Sustainability/Index.vue'),
    meta: {
      pageTitle: 'Kurumsal',
      breadcrumb: [
        {
          text: 'Sürdürülebilirlik',
          active: true,
        },
      ],
      resource: 'ADMIN_SUSTAINABILITY',
      action: 'read',
    },
  },
]
